module.exports = __webpack_public_path__ + "static/img/logo.e0e5b9f1.png";